export default __webpack_public_path__ + "static/anatomy-b32fb2528f54f9d340ae00db517c0246.png";